import Vue from "vue";
import Vuex from "vuex";
import http from "../../service/data-service";

export default {
  state: {
    relatorioApostas: null,
  },
  getters: {
    relatorioApostas(state: any) {
      return state.relatorioApostas;
    },
  },
  mutations: {
    setRelatorioApostas(state: any, relatorioApostas: any) {
      state.relatorioApostas = relatorioApostas;
    },
  },
  actions: {
    getRelatorioApostas({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {
        let p : any = '';
        if(payload.numero){
          	p+='numero='+payload.numero;
        }
        if(payload.dataInicial){
          p+=(p!=''?'&':'')+'dataInicial='+payload.dataInicial;
        }
        if(payload.dataFinal){
          p+=(p!=''?'&':'')+'dataFinal='+payload.dataFinal;
        }
        p = p.replaceAll("/", "%2F");
        http
          .get("/api/v1/relatorio/relatorioApostas?"+p )
          .then((result: any) => {
            commit("setUrlReset", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    getRelatorioCaixa({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {
        let p : any = '';
        if(payload.tipo){
          	p+='tipo='+payload.tipo;
        }
        if(payload.dataInicial){
          p+=(p!=''?'&':'')+'dataInicial='+payload.dataInicial;
        }
        if(payload.dataFinal){
          p+=(p!=''?'&':'')+'dataFinal='+payload.dataFinal;
        }
        p = p.replaceAll("/", "%2F");
        http
          .get("/api/v1/relatorio/relatorioCaixa?nome="+payload.nome+"&tipo="+payload.tipo+"&dataInicial="+payload.dataInicial+"&dataFinal="+payload.dataFinal )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    getRelatorioPremium({ commit }: { commit: any }, payload: any) {
      return new Promise((resolve, reject) => {
        let p : any = '';
        if(payload.tipo){
          	p+='tipo='+payload.tipo;
        }
        if(payload.situacao){
          p+=(p!=''?'&':'')+'situacao='+payload.situacao;
        }
        if(payload.dtInicAtivacao){
          p+=(p!=''?'&':'')+'dtInicAtivacao='+payload.dtInicAtivacao;
        }
        if(payload.dtFinaAtivacao){
          p+=(p!=''?'&':'')+'dtFinaAtivacao='+payload.dtFinaAtivacao;
        }
        p = p.replaceAll("/", "%2F");
        http
          .get("/api/v1/relatorio/relatorioPremium?"+p )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    getRelatorioBolaoArmazenado({ commit }: { commit: any }, id: any) {
      return new Promise((resolve, reject) => {
       
        http
          .get("/api/v1/relatorio/relatorioBolaoArmazenado/"+id )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
  },
};
